import React from 'react';
import {
  IInfrastructureTypeVideo,
} from 'src/components/ViewSpinner/components/RenderSvg/components/InfrastructureType/types';
import { ButtonApp } from 'src/components/Button';

export const InfrastructureButton: React.FC<IInfrastructureTypeVideo> = ({
  data,
}) => {
  const clickHandler = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <>
      {
        data['infrastructure.links'] && data['infrastructure.links'].map((link) => {
          return (
            <ButtonApp
              key={link['infrastructure_links.link_text']}
              isFullSize
              text={link['infrastructure_links.link_text']}
              variant="contained"
              onClick={() => clickHandler(link['infrastructure_links.link_data'])}
            />
          );
        })
      }
    </>
  );
};
